import { forwardRef, memo } from 'react';
import { classNames } from '../../utils/classNames';
import type { HTMLAttributes, CSSProperties } from 'react';
import React from 'react';
interface EmptyStateProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
  className?: string;
  styleOverrides?: CSSProperties;
}

const EmptyStateComponent = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, styleOverrides, ...restProps }, ref) => {
    return (
      <div
        ref={ref}
        className={classNames('comment-list', 'comment-list--empty', className)}
        style={styleOverrides}
        {...restProps}
      >
        <div className="comment-list__empty">
          <p>No comments yet. Be the first to add a comment!</p>
        </div>
      </div>
    );
  }
);

EmptyStateComponent.displayName = 'EmptyState';

export const EmptyState = memo(EmptyStateComponent);
